import { render, staticRenderFns } from "./DisabledCheckbox.vue?vue&type=template&id=523b2af4&"
import script from "./DisabledCheckbox.vue?vue&type=script&lang=js&"
export * from "./DisabledCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports